import Slider, { SliderThumb } from '@mui/material/Slider';
import styled from "styled-components";
//import { cityCoins } from "../../lib/currency";
import './style.scss';

const BlockStxInputSlider = styled(Slider)(({ colorscheme1, colorscheme2 }) => ({
    color: 'rgb(247, 147, 26, 0.5)',
    height: 8,
    '& .MuiSlider-track': {
        border: 'none',
        backgroundImage: colorscheme1,
    },
    '& .MuiSlider-thumb': {
        height: 30,
        width: 30,
        backgroundColor: '#fff',
        border: '1.5px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&::before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 8,
        background: 'unset',
        padding: 0,
        width: 20,
        height: 20,
        borderRadius: '50% 50% 50% 0',
        backgroundImage: colorscheme2,
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&::before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(120%, 20%) rotate(45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(-45deg)',
        },
    },
}));

const StrategySlider = styled(Slider)(() => ({
    color: 'rgb(247,147,26,0.5)',
    height: 8,
    '& .MuiSlider-thumb': {
        height: 30,
        width: 30,
        backgroundColor: '#fff',
        border: '1.5px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&::before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 8,
        background: 'unset',
        padding: 0,
        width: 160,
        height: 20,
        // borderRadius: '50% 50% 50% 0',
        backgroundColor: 'grey',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%)  scale(0)',
        '&::before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(60%, 70%)  scale(1)',
        },
        '& > *': {
            // transform: 'rotate(-45deg)',
        },
    },
}))

const MineValuesSliders = ({ selectedMineCity, setBlocks, setStxInput, setStrategy, blocks, stxInput, strategy }) => {

    function handleBlockChange(event, val) {
        setBlocks(val);
    }
    function handleStxInputChange(event, val) {
        setStxInput(val);
    }
    function handleStrategyChange(event, val) {
        setStrategy(1);
    }

    function BlockStxInputSliderThumbComponent(props) {
        const { children, ...other } = props;
        return (
            <SliderThumb {...other}>
                {children}
                <img src={props?.ownerState?.iconsrc} alt="" height={'100%'} width={'100%'} style={{ objectFit: 'cover', display: 'block' }} />
            </SliderThumb>
        );
    }

    function StrategySliderThumbComponent(props) {
        const { children, ...other } = props;
        return (
            <SliderThumb {...other}>
                {children}
                <img src={props?.ownerState?.iconsrc} alt="" height={'70%'} width={'70%'} style={{ objectFit: 'cover', display: 'block' }} />
            </SliderThumb>
        );
    }

    return (
        <>
            <BlockStxInputSlider valueLabelDisplay="auto" aria-label="block slider" defaultValue={20} min={1} step={1} max={200} value={blocks} onChange={handleBlockChange} iconsrc={'/32-cc.png'} slots={{ thumb: BlockStxInputSliderThumbComponent }} colorscheme1={"linear-gradient(to left, #F7931A, #6444fe)"} colorscheme2={"linear-gradient(to right, #F7931A, #6444fe)"} />
            <BlockStxInputSlider valueLabelDisplay="auto" aria-label="stxinput slider" defaultValue={2} min={0.1} step={0.1} max={20} value={stxInput} onChange={handleStxInputChange} aria-labelledby="non-linear-slider" iconsrc={'/32-stx.png'} slots={{ thumb: BlockStxInputSliderThumbComponent }} colorscheme1={"linear-gradient(to left, #5d2ce9 , #5d2ce9)"} colorscheme2={"linear-gradient(to left, #5d2ce9 , #5d2ce9)"} />
            <StrategySlider aria-label="strategy slider" defaultValue={1} value={strategy} onChange={handleStrategyChange} valueLabelDisplay="auto" valueLabelFormat={() => 'Even Mining Strategy (more coming soon)'} iconsrc={'/16-even.png'} slots={{ thumb: StrategySliderThumbComponent }} step={1} marks min={1} max={8} />
        </>
    )
}

export default MineValuesSliders;